module.exports = __webpack_public_path__ + "static/media/JSWSTEEL.84217e4f.txt";